import { EntityType } from '@frontend/common';
import { LabelTemplateClient } from '@frontend/label/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useLabelTemplate:request': CustomEvent<string>;
    }
}

const REQUEST_LABEL_TEMPLATE_EVENT = 'useLabelTemplate:request';
const STORAGE_KEY = 'LABELTMP_REQ';

export function labelTemplateRequest(labelTemplateId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_LABEL_TEMPLATE_EVENT, { detail: labelTemplateId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function LabelTemplateResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_LABEL_TEMPLATE_EVENT, EntityType.LABEL_TEMPLATE, (ids) => LabelTemplateClient.resolveLabelTemplates(ids), props.dispatch);
    return <></>;
}
